import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';

import PanelClients from './pages/PanelClientes';
import PanelAdmin from './pages/PanelAdmin'; 
import Login from './pages/Login';
import Clientes from './pages/Clientes';
import RegistrarClientes from './pages/RegistrarClientes';
import Productos from './pages/Productos';
import CrearProductos from './pages/CrearProductos';
import CrearPedido from './pages/CrearPedido';
import PedidosPendientes from './pages/PedidosPendientes';
import PedidosFinalizados from './pages/PedidosFinalizados';
import PerfilUsuario from './pages/PerfilUsuario';
import RegistrarUsuario from './pages/RegistrarUsuario';
import Usuarios from './pages/Usuarios';

// Componente que protege las rutas
const RutaProtegida = () => {
  const token = localStorage.getItem('token');
  return token ? <Outlet /> : <Navigate to="/iniciar-sesion" />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Página pública: Login */}
        <Route path="/iniciar-sesion" element={<Login />} />

        {/* Rutas protegidas del cliente */}
        <Route element={<RutaProtegida />}>
          <Route path="/" element={<PanelClients />}>
            <Route index element={<Clientes />} />
            <Route path="clientes" element={<Clientes />} />
            <Route path="registrar-clientes" element={<RegistrarClientes />} />
            <Route path="productos" element={<Productos />} />
            <Route path="registrar-productos" element={<CrearProductos />} />
            <Route path="registrar-pedidos" element={<CrearPedido />} />
            <Route path="pedidos" element={<PedidosPendientes />} />
            <Route path="pedidos-entregados" element={<PedidosFinalizados />} />
            <Route path="perfil" element={<PerfilUsuario />} />
          </Route>
        </Route>

        {/* Rutas protegidas del admin */}
        <Route element={<RutaProtegida />}>
          <Route path="/panel-admin" element={<PanelAdmin />}>
            <Route index element={<RegistrarUsuario />} />
            <Route path="registrar-usuarios" element={<RegistrarUsuario />} />
            <Route path="usuarios" element={<Usuarios />} />
          </Route>
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;
